import { Plugin } from "@ckeditor/ckeditor5-core";
import {
  createDropdown,
  addListToDropdown,
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import { UIModel as Model } from "@ckeditor/ckeditor5-ui";
import { Collection } from "@ckeditor/ckeditor5-utils";

import ContainIcon from "./contain.svg";

export default class LineRefsUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;

    const buttons = [
      {
        label: "Line Ref Start",
        range: "startOnly",
      },
      {
        label: "Line Ref End",
        range: "endOnly",
      },
      {
        label: "Line Ref",
        range: "both",
      },
    ];

    editor.ui.componentFactory.add("createLineRef", (locale) => {
      const command = editor.commands.get("createLineRef");
      const dropdownView = createDropdown(locale);

      dropdownView.buttonView.set({
        icon: ContainIcon,
        isOn: false,
        label: t("Create Line Ref"),
        tooltip: true,
      });

      const options = new Collection();

      buttons.map(({ label }) => {
        options.add({
          type: "button",
          model: new Model({
            label,
            withText: true,
          }),
        });
      });

      addListToDropdown(dropdownView, options);

      dropdownView.bind("isEnabled").to(command);
      dropdownView.on("execute", (e) => {
        const { label } = e.source;
        const { range } = buttons.find((b) => b.label === label);

        command.execute({ range });
      });
      return dropdownView;
    });
  }
}
